import mitt from "mitt";

const emitter = mitt();

// 全局事件总线（兼容 Vue 2 EventBus API）
export const EventBus = {
  $emit: (event, ...args) => emitter.emit(event, ...args),
  $on: (event, handler) => emitter.on(event, handler),
  $off: (event, handler) => emitter.off(event, handler),
};

export const EVENTS = {
  SHOW_CREATE_PROJECT: "show-create-project",
  HIDE_CREATE_PROJECT: "hide-create-project",
  SHOW_CREDITS_DIALOG: "show-credits-dialog",
  SHOW_COMMUNITY_DIALOG: "show-community-dialog",
  SHOW_PROFILE_DIALOG: "show-profile-dialog",
  SHOW_MESSAGE_CENTER: "show-message-center",
  REFRESH_USER_INFO: "refresh-user-info",
};

export function showCreateProjectDialog() {
  EventBus.$emit(EVENTS.SHOW_CREATE_PROJECT);
}

export function hideCreateProjectDialog() {
  EventBus.$emit(EVENTS.HIDE_CREATE_PROJECT);
}
